import React, { useMemo, useState } from 'react'
import { Link, withRouter } from 'react-router-dom'
import Button from '../../../../../Components/Buttons/Button'
import FoldedText from '../../../../../Components/Text/FoldedText'
import { getLastClassRecording, getNextClass } from '../../../Helpers/Timings'
import withStore from '../../../../../Components/Unstated/withStore'
import CourseStore from '../../../Store/CourseStore'
import date from 'date-and-time'
import { getField } from '../../../../../Helpers/Misc'
import UserStore from '../../../../UserAuth/Store/UserStore'
import EmbedModal from './EmbedModal'
import DocumentsViewerStore from '../../../../../Modules/Documents/Viewer/Store/DocumentsViewerStore'
import useTime from '../../../../../Helpers/CustomHooks/useTime'
import { useToggle } from 'react-use'
import ShareOutlinedIcon from '@material-ui/icons/ShareOutlined'
import ShareModal from '../../../../../Components/ShareModal'
import { Text } from '../../../../../Styles/typography'
import ReactPlayer from 'react-player'
import { withStoreProvider } from '../../../../../Helpers/withStoreProvider'
import PricingStore from '../../../../Pricing/home/stores/pricing-store'

const Header = ({
  courseStore: {
    state,
    wishlist,
    updateCourseDataAdmin,
    followTeacher,
    enrollRecorded,
  },
  userStore: {
    state: { loggedIn },
  },
  documentsViewerStore: { openDocument },
  history,
  location,
  restricted,
  editMode,
  groupReg,
}) => {
  const [disabled, toggle] = useToggle(false)
  const time = useTime(1000)
  const [embed, toggleEmbed] = useState(false)
  const nextClass = state.isEnrolled && getNextClass(state.enrollments)
  const lastClassRecording = getLastClassRecording(state.enrollments)
  const [showShare, setShowShare] = useState(false)
  const { activeSubscription = [] } = PricingStore.useContainer()

  const subscriptionDiscount = useMemo(
    () => activeSubscription[0]?.discounts?.course || 0,
    [activeSubscription],
  )

  const finalDiscount = useMemo(() => {
    const discount = state?.discount || 0
    return discount + ((100 - discount) * subscriptionDiscount) / 100
  }, [state, subscriptionDiscount])

  const fee = (() => {
    const data = state.stdFee || state.fee
    return {
      ...data,
      amount: data.amount * ((100 - (finalDiscount || 0)) / 100),
    }
  })()

  const pendingGroupEnrollment =
    state.type === 'live' &&
    state.isGroupCourse &&
    (state?.pendingEnrollmentRequest ||
      (state?.enrollments[0]?.billStatus &&
        state?.enrollments[0]?.billStatus === 'NOT_PAID'))

  const enrolledInGroup =
    state.type === 'live' &&
    state.isGroupCourse &&
    state?.enrollments.find(
      (enrollment) =>
        enrollment?.billStatus === 'PAID' || enrollment?.status === 'APPROVED',
    )

  const pendingRecordedEnrollment =
    state.type === 'recorded' && state.enrollments[0]?.status === 'REGISTERED'
  const enrolledInRecorded =
    state.type === 'recorded' && state.enrollments[0]?.status === 'PAID'

  const unpaid =
    state.enrollments[0]?.billId &&
    state.enrollments[0].billStatus === 'NOT_PAID'

  return (
    <div
      className='header'
      onInput={(e) =>
        updateCourseDataAdmin({
          [e.target.getAttribute('data-edit-name')]: e.target.innerText,
        })
      }
    >
      <div className='cover'>
        {state?.coverVideo || state?.teacher?.externalProfileVideo ? (
          <ReactPlayer
            width='91.75%'
            height='30em'
            url={state?.coverVideo || state?.teacher?.externalProfileVideo}
            playing
            muted
            controls
          />
        ) : (
          <div
            className='image'
            style={{
              background: `url(${state.cover}) center center /contain no-repeat`,
            }}
          />
        )}
      </div>
      <div className='content'>
        <h1 className='name' contentEditable={editMode} data-edit-name='title'>
          {state.name}
          <div className='share-btn'>
            <ShareOutlinedIcon onClick={() => setShowShare(true)} />
            {showShare && (
              <ShareModal
                close={() => setShowShare(false)}
                url={`${process.env.REACT_APP_SITE_URL}${location.pathname}`}
                courseName={state.name}
                teacherName={state.teacher?.name}
                courseType={'Course'}
              />
            )}
          </div>
        </h1>
        <p
          className='teacherName'
          style={restricted ? { pointerEvents: 'none' } : {}}
        >
          By{' '}
          <Link to={`/${state.livDemyID}`}>
            <span>{state.teacher.name}</span>{' '}
          </Link>
          <Button
            className='follow'
            onClick={() => followTeacher()}
            icon={state.doFollow ? 'tickIcon' : 'plusIcon'}
            name={state.doFollow ? 'Following' : 'Follow'}
            type={'secondary'}
            requiresLogin
          />
        </p>
        <div className='description'>
          <FoldedText
            initialCharacters={500}
            contentEditable={editMode}
            data-edit-name='courseDescription'
          >
            {state.description}
          </FoldedText>
        </div>
        <div className='basic-info'>
          {/* <Text>Batch size of {state.batchLimit} students</Text> */}
          {state.teacher?.languages?.length > 0 && (
            <Text>Languages: {state.teacher?.languages.join(', ')}.</Text>
          )}
        </div>
        {(!state.isEnrolled || !nextClass) && (
          <>
            <div className='fee'>
              {getField(fee, 'currency')}{' '}
              {Math.ceil(Number(getField(fee, 'amount')) / state.noOfClasses)}
              <span> / class (approx)</span>
              <Text className='fee-class-info'>
                {' '}
                {state.noOfClasses} classes. (Includes Study Material)
              </Text>
            </div>
            {state.userType !== 'teacher' && !restricted && (
              <div className='buttons'>
                <>
                  {pendingGroupEnrollment && state.isApprovalReq ? null : (
                    <Button
                      onClick={async () => {
                        if (state.userType === 'anonymous') {
                          history.push({
                            pathname: '/auth/login',
                            state: { from: location },
                          })
                        } else {
                          if (state.type === 'live' && !state.isGroupCourse) {
                            document
                              .querySelector('.courseDashboard .details')
                              .scrollIntoView({
                                behavior: 'smooth',
                                block: 'start',
                              })
                            window.updateTab.courseDetailsTab(2)
                          } else if (pendingRecordedEnrollment) {
                            history.push(
                              `/billing/payment/${state.enrollments[0]?.billId}`,
                            )
                          } else if (state.isGroupCourse) {
                            groupReg(true)
                          } else {
                            toggle(true)
                            const success = await enrollRecorded()
                            if (success) {
                              history.push(`/billing/payment/${success.billId}`)
                            }
                            toggle(false)
                          }
                        }
                      }}
                      disabled={disabled || enrolledInRecorded}
                      loading={disabled}
                      name={
                        enrolledInRecorded
                          ? 'Registered'
                          : pendingRecordedEnrollment
                          ? 'Complete Registration'
                          : pendingGroupEnrollment && state.isApprovalReq
                          ? 'View Requested Slots'
                          : 'Register'
                      }
                      type={'primary big'}
                    />
                  )}
                  <Button
                    onClick={() =>
                      loggedIn
                        ? wishlist()
                        : history.push({
                            pathname: '/auth/login',
                            state: { from: location },
                          })
                    }
                    icon={!state.wishListed ? 'heart' : 'whiteheart'}
                    name={
                      !state.wishListed ? 'Wishlist' : 'Remove from Wishlist'
                    }
                    type={'border big'}
                  />
                </>
              </div>
            )}
          </>
        )}
        {nextClass &&
          !(
            time > Number(nextClass.startTime) &&
            time < Number(nextClass.endTime)
          ) && (
            <h1 className='nextClass'>
              Next scheduled class: <br />
              {date.format(
                new Date(nextClass.startTime),
                'DD MMMM, YYYY [ from ]hh:mm[ - ]',
              )}
              {date.format(new Date(nextClass.endTime), 'hh:mm A')}
            </h1>
          )}

        {state.isGroupCourse &&
          (enrolledInGroup || state.userType === 'teacher') && (
            <div className='buttons'>
              {unpaid && state.isGroupCourse ? (
                <Button
                  onClick={() =>
                    history.push(
                      `/billing/payment/${state.enrollments[0]?.billId}`,
                    )
                  }
                >
                  Pay Now
                </Button>
              ) : null}
              <Link to={`${location?.pathname}/dashboard`}>
                <Button
                  onClick={() => {}}
                  name={'Go to Course Dashboard'}
                  type={'primary big'}
                />
              </Link>
            </div>
          )}

        {state.isEnrolled &&
          nextClass &&
          Number(nextClass.startTime) < time &&
          Number(nextClass.endTime) > time && (
            <Link to={'/classroom'}>
              <Button
                onClick={() => {}}
                type={'primary'}
                name={'Go to class'}
              />
            </Link>
          )}
        {lastClassRecording && (
          <Button
            onClick={() =>
              openDocument({
                name: 'Last class recording',
                type: 'playlist',
                url: Object.values(lastClassRecording).map(({ url }) => url),
              })
            }
            name={'Rewatch last class'}
            type={'primary'}
          />
        )}
        <div className='embedIcon' onClick={() => toggleEmbed(true)}>
          <div className='icon' />
          <p>Embed Course</p>
        </div>
        {embed && (
          <EmbedModal
            close={() => toggleEmbed(false)}
            title={state.name}
            src={`${process.env.REACT_APP_SITE_URL}/embed/course/${state.livDemyID}/${state.courseURL}`}
          />
        )}
      </div>
    </div>
  )
}

export default withStore([UserStore, CourseStore, DocumentsViewerStore])(
  withStoreProvider([PricingStore])(withRouter(Header)),
)
